import QuizPagination from './QuizPagination';
export default QuizPagination;